const MonitoringInterface = require("./monitoring.interface");

function Datadog($window, $log) {
    /**
     * Logs the provided error to Datadog along with any provided custom attributes,
     * then re-throws the error.
     * @method logAndRethrow
     * @param {Error} error
     * @param {string} module
     * @param {string} method
     * @param {CustomAttributes} [customAttributes]
     */
    this.logAndRethrow = function (error, module, method, customAttributes) {
        this.noticeError(error, module, method, customAttributes);
        throw error;
    };

    /**
     * Captures a page action in Datadog.
     * @method addPageAction
     * @param {string} actionName name of the page action
     * @param {CustomAttributes} [customAttributes]
     */
    this.addPageAction = function (actionName, customAttributes) {
        if ($window.DD_LOGS) {
            $window.DD_LOGS.logger.info(actionName, customAttributes);
        } else {
            $log.warn(`Datadog is not initialized. Skipping addPageAction: ${actionName}`);
        }
    };

    /**
     * Submits an error report to Datadog.
     * @method noticeError
     * @param {Error} error
     * @param {string} module
     * @param {string} [method]
     * @param {CustomAttributes} [customAttributes]
     */
    this.noticeError = function (error, module, method, customAttributes) {
        if ($window.DD_LOGS) {
            customAttributes = customAttributes || {};
            customAttributes.module = module;
            customAttributes.method = method;
            if (error && error.message) {
                $window.DD_LOGS.logger.error(error.message, customAttributes, error);
            } else {
                $window.DD_LOGS.logger.error(error, customAttributes);
            }
        } else {
            $log.warn(`Datadog is not initialized. Error logged locally: ${error}`);
        }
    };

    /**
     * Sets the custom event attribute as a custom attribute in Datadog.
     * @method setCustomEventAttribute
     * @param {string} customEventAttributeKey
     * @param {object} customEventAttributeValue
     */
    this.setCustomEventAttribute = function (customEventAttributeKey, customEventAttributeValue) {
        if ($window.DD_LOGS) {
            $window.DD_LOGS.setUserProperty(customEventAttributeKey, customEventAttributeValue);
        } else {
            $log.warn(`Datadog is not initialized. Skipping setCustomEventAttribute: ${customEventAttributeKey}`);
        }
    };

}

Datadog.prototype = Object.create(MonitoringInterface.prototype);

module.exports = function (app) {
    app.service("Datadog", Datadog);
};